var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8, _g9, _circle, _path2, _path3, _g10, _g11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingBikeIncreasedbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1224.72 1043.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingBikeIncreased_before_svg__cls-3{fill:#343a50}.parkingBikeIncreased_before_svg__cls-5{fill:#fff;opacity:.32}.parkingBikeIncreased_before_svg__cls-6{fill:#eb9a6b}.parkingBikeIncreased_before_svg__cls-7{fill:#cc825c}.parkingBikeIncreased_before_svg__cls-8{fill:#7fc3ca}.parkingBikeIncreased_before_svg__cls-14,.parkingBikeIncreased_before_svg__cls-19,.parkingBikeIncreased_before_svg__cls-24,.parkingBikeIncreased_before_svg__cls-25,.parkingBikeIncreased_before_svg__cls-28,.parkingBikeIncreased_before_svg__cls-30,.parkingBikeIncreased_before_svg__cls-32,.parkingBikeIncreased_before_svg__cls-34,.parkingBikeIncreased_before_svg__cls-37,.parkingBikeIncreased_before_svg__cls-38,.parkingBikeIncreased_before_svg__cls-8,.parkingBikeIncreased_before_svg__cls-9{stroke:#343a50}.parkingBikeIncreased_before_svg__cls-14,.parkingBikeIncreased_before_svg__cls-19,.parkingBikeIncreased_before_svg__cls-24,.parkingBikeIncreased_before_svg__cls-25,.parkingBikeIncreased_before_svg__cls-27,.parkingBikeIncreased_before_svg__cls-28,.parkingBikeIncreased_before_svg__cls-32,.parkingBikeIncreased_before_svg__cls-33,.parkingBikeIncreased_before_svg__cls-34,.parkingBikeIncreased_before_svg__cls-36,.parkingBikeIncreased_before_svg__cls-37,.parkingBikeIncreased_before_svg__cls-38,.parkingBikeIncreased_before_svg__cls-8{stroke-miterlimit:10}.parkingBikeIncreased_before_svg__cls-14,.parkingBikeIncreased_before_svg__cls-19,.parkingBikeIncreased_before_svg__cls-8,.parkingBikeIncreased_before_svg__cls-9{stroke-width:2px}.parkingBikeIncreased_before_svg__cls-43,.parkingBikeIncreased_before_svg__cls-9{fill:#dedede}.parkingBikeIncreased_before_svg__cls-30,.parkingBikeIncreased_before_svg__cls-9{stroke-linecap:round;stroke-linejoin:round}.parkingBikeIncreased_before_svg__cls-14{fill:#3b3b3b}.parkingBikeIncreased_before_svg__cls-13{fill:#2cb4c3}.parkingBikeIncreased_before_svg__cls-19{fill:#8a2519}.parkingBikeIncreased_before_svg__cls-24{fill:#191919}.parkingBikeIncreased_before_svg__cls-25,.parkingBikeIncreased_before_svg__cls-32{fill:#857d7a}.parkingBikeIncreased_before_svg__cls-27,.parkingBikeIncreased_before_svg__cls-33,.parkingBikeIncreased_before_svg__cls-36{fill:none;stroke:#191919}.parkingBikeIncreased_before_svg__cls-27{stroke-width:4.5px}.parkingBikeIncreased_before_svg__cls-28,.parkingBikeIncreased_before_svg__cls-30{fill:#6784b3}.parkingBikeIncreased_before_svg__cls-32,.parkingBikeIncreased_before_svg__cls-38{stroke-width:3px}.parkingBikeIncreased_before_svg__cls-33{stroke-width:2.35px}.parkingBikeIncreased_before_svg__cls-34{fill:#f84c34}.parkingBikeIncreased_before_svg__cls-36{stroke-width:3.68px}.parkingBikeIncreased_before_svg__cls-37,.parkingBikeIncreased_before_svg__cls-38{fill:#46bea9}.parkingBikeIncreased_before_svg__cls-42{mix-blend-mode:multiply}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fahrradstellpl\\xE4tze_Vorher"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Himmel"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "-1.02 460.31 -1.02 -37.92 1259.03 -37.92 1260.05 460.31 -1.02 460.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258-36.89l1 496.17H0V-36.89h1258m2.06-2.06H-2v500.29h1263.09v-2.07l-1-496.17v-2.05z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260.16,
    height: 614.29,
    x: -1.07,
    y: 429.67,
    fill: "#a9bf5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 430.52l1258.15.3-.15 612.29-1258.14-.31L0 430.52m-2-2v2l-.15 612.28v2h2l1258.15.31h2v-2l.15-612.29v-2h-2L0 428.51z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.12 81.22c10.22-24 36.07-41.16 66.58-41.16 30.15 0 55.81 16.71 66.27 40.27a54.76 54.76 0 0113.49-1.86c27.54 0 49.85 19.9 49.85 44.44s-22.31 44.45-49.85 44.45h-129.6c-27.54 0-49.85-19.9-49.85-44.45-.01-19.28 13.86-35.54 33.11-41.69zM121.6 42.05c6.09-14.3 21.47-24.51 39.64-24.51 17.95 0 33.23 10 39.46 24a32.55 32.55 0 018-1.11c16.39 0 29.68 11.85 29.68 26.46s-13.29 26.46-29.68 26.46h-77.14c-16.39 0-29.68-11.84-29.68-26.46 0-11.5 8.26-21.18 19.72-24.84zM447.71 66.71c-6.61-15.55-23.35-26.65-43.1-26.65-19.52 0-36.13 10.82-42.91 26.07a35.64 35.64 0 00-8.73-1.2c-17.83 0-32.27 12.88-32.27 28.77s14.44 28.77 32.27 28.77h83.91c17.83 0 32.27-12.88 32.27-28.77 0-12.49-8.97-23.01-21.44-26.99zM960.32 4.91c5.75-13.5 20.27-23.13 37.42-23.13 16.94 0 31.36 9.39 37.24 22.62a30.81 30.81 0 017.58-1c15.47 0 28 11.18 28 25s-12.54 25-28 25h-72.83c-15.48 0-28-11.18-28-25-.02-10.9 7.77-20.04 18.59-23.49z",
    className: "parkingBikeIncreased_before_svg__cls-5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Haus_hinten_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 610.94,
    height: 208.63,
    x: 451.21,
    y: 266.64,
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.14 267.64v206.64H452.21V267.64h608.93m2-2H450.21v210.64h612.93V265.64z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174.46,
    height: 208.63,
    x: 451.21,
    y: 266.64,
    className: "parkingBikeIncreased_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.67 267.64v206.64H452.21V267.64h172.46m2-2H450.21v210.64h176.46V265.64z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.11,
    height: 158.04,
    x: 468.84,
    y: 282.65,
    className: "parkingBikeIncreased_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.64 440.69 512.64 366.42 468.83 366.42 468.83 356.91 512.64 356.91 512.64 282.64 522.15 282.64 522.15 356.91 565.95 356.91 565.95 366.42 522.15 366.42 522.15 440.69 512.64 440.69",
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.15 283.65v74.26H565v7.51h-43.8v74.27h-7.51v-74.27h-43.8v-7.51h43.8v-74.26h7.51m2-2h-11.56v74.26h-43.8v11.51h43.8v74.27h11.51v-74.27H567v-11.51h-43.8v-74.26z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.11,
    height: 158.04,
    x: 861.65,
    y: 282.65,
    className: "parkingBikeIncreased_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "905.45 441.16 905.45 366.42 861.65 366.42 861.65 356.91 905.45 356.91 905.45 282.64 914.96 282.64 914.96 356.91 959.25 356.91 959.25 366.42 914.96 366.42 914.96 441.16 905.45 441.16",
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 283.64v74.27h44.29v7.51H914v74.74h-7.51v-74.74h-43.85v-7.51h43.81v-74.27H914m2-2h-11.55v74.26h-43.8v11.51h43.8v74.74H916v-74.73h44.29v-11.51H916v-74.26z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89.32,
    height: 158.04,
    x: 973.57,
    y: 282.65,
    className: "parkingBikeIncreased_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.51,
    height: 156.04,
    x: 1017.38,
    y: 283.65,
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.88 284.65v154h-7.5v-154h7.5m2-2h-11.5v158h11.5v-158z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87.36,
    height: 9.51,
    x: 974.53,
    y: 356.91,
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.89 357.91v7.51h-85.36v-7.51h85.36m2-2h-89.36v11.51h89.36v-11.51z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.45,
    height: 181.24,
    x: 680.22,
    y: 294.03,
    className: "parkingBikeIncreased_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.67 295v179.28H681.22V295h155.45m2-2H679.22v183.28h159.45V293z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 125.61,
    height: 170.11,
    x: 695.06,
    y: 305.16,
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.67 306.16v168.12H696.06V306.16h123.61m2-2H694.06v172.12h127.61V304.16z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 159.83,
    x: 718.94,
    y: 315.01,
    className: "parkingBikeIncreased_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "756.81 475.28 756.81 434.08 718.94 434.08 718.94 429.93 756.81 429.93 756.81 392.04 718.94 392.04 718.94 387.89 756.81 387.89 756.81 349.83 718.93 349.83 718.93 345.67 756.81 345.67 756.81 315 761.08 315 761.08 345.67 798.94 345.67 798.94 349.83 761.08 349.83 761.08 387.89 798.94 387.89 798.94 392.04 761.08 392.04 761.08 429.93 798.94 429.93 798.94 434.08 761.08 434.08 761.08 475.28 756.81 475.28",
    className: "parkingBikeIncreased_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.08 316v30.67h37.86v2.16h-37.86v40.05H798V391h-37.92v39.89H798v2.15h-37.92v41.2h-2.27v-41.2h-37.87v-2.15h37.87V391h-37.87v-2.16h37.87v-40.01h-37.88v-2.16h37.88V316h2.27m2-2h-6.26v30.68h-37.88v6.14h37.87v36.07h-37.87V393h37.87v35.89h-37.87v6.15h37.87v41.2h6.26v-41.2h37.87v-6.15h-37.87V393h37.87v-6.15h-37.87v-36.03h37.87v-6.14h-37.87V314z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 681.66,
    x2: 695.52,
    y1: 294.87,
    y2: 305.26,
    className: "parkingBikeIncreased_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 836.5,
    x2: 819.96,
    y1: 295.34,
    y2: 305.55,
    className: "parkingBikeIncreased_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b4b45",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "1259.02 221.73 935.18 111.77 450.21 265.64 1259.3 265.64 1259.02 221.73"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Haus_vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 376.86,
    height: 486.55,
    x: 882.16,
    y: 372.86,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "1259.02 70.87 1079.75 70.87 881.94 373.2 1259.02 373.2 1259.02 70.87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fenster"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1258.11 624.03 1081.24 624.03 1081.24 442.67 1258 442.67 1258.11 624.03",
    className: "parkingBikeIncreased_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.07 820.38 1081.24 820.38 1081.24 639.02 1258.11 639.02 1258.07 820.38",
    className: "parkingBikeIncreased_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.17 528.62v-85.95H1259v-10.74h-188.5v399.19H1259v-10.74h-84.85v-86H1259V725h-84.85v-86H1259v-15h-84.85v-85.92H1259v-9.46zm-9.46 291.76h-83.47v-86h83.47zm0-95.41h-83.47V639h83.47zm-83.47-282.3h83.47v85.95h-83.47zm0 95.41h83.47V624h-83.47z",
    className: "parkingBikeIncreased_before_svg__cls-14"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 188.19,
    height: 322.86,
    x: 693.97,
    y: 536.55,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "692.24 536.55 882.16 536.55 882.16 420.06 881.47 420.06 692.24 536.55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.99,
    height: 113.99,
    x: 731.07,
    y: 577.77,
    className: "parkingBikeIncreased_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.32 571v127.51h127.49V571zm6.75 6.75h52.47v54h-52.47zm0 114v-54h52.47v54zm114 0h-55.59v-54h55.58zm0-60h-55.59v-54h55.58z",
    className: "parkingBikeIncreased_before_svg__cls-14"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Haus_hinten_links"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fasade",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 299.95,
    x: -235.93,
    y: 271.52,
    fill: "#f2ab80",
    transform: "rotate(-180 -5.07 421.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 84.34,
    x: -235.93,
    y: 487.13,
    fill: "#ca9072",
    transform: "rotate(-180 -5.07 529.295)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "parkingBikeIncreased_before_svg__Tuer",
    d: "M-50.27 394.19h97.78v128.2a48.86 48.86 0 01-48.86 48.86h-.06a48.86 48.86 0 01-48.86-48.86v-128.2z",
    className: "parkingBikeIncreased_before_svg__cls-19",
    transform: "rotate(180 -1.385 482.715)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.61,
    height: 20.25,
    x: -64.55,
    y: 551.22,
    fill: "#9a9a9a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 -1.24 561.345)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fenster-3",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.76,
    height: 77.06,
    x: 77.11,
    y: 336.13,
    fill: "#7fc3ca",
    transform: "rotate(-180 109.485 374.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.65 336.13v-5.26a3.23 3.23 0 00-3.23-3.23H75.55a3.23 3.23 0 00-3.23 3.23V418.44a3.23 3.23 0 003.23 3.23h67.85a3.23 3.23 0 003.22-3.23v-5.26h.06v-77.05zm-4.79 34.28h-30v-34.28h30zm-34.78-34.28v34.28h-30v-34.28zm-30 42.77h30v34.28h-30zm34.78 34.28V378.9h30v34.28z",
    className: "parkingBikeIncreased_before_svg__cls-19"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#555",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-249.09 275.7 -2.33 83.09 245.1 275.7 -249.09 275.7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "parkingBikeIncreased_before_svg__Weg",
    fill: "#eec6a2",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M730.85 1154.1c-142.57-11.88-282.83-34.72-376.38-118.34-53-47.4-72.91-85.24-88.88-115.64-14.85-28.27-25.58-48.69-62.73-75.49C125 788.49 36.25 783.1-57.72 777.38c-97.67-5.93-196.21 5.83-292.89 35l-25.68-85.21C-269.51 695-160.52 682-52.32 688.55c102.49 6.23 208.48 12.67 307.24 83.9 54.14 39 72.1 73.22 89.46 106.28 14.58 27.77 28.36 54 69.4 90.67 79 70.63 185.87 113.38 309 123.64a563.79 563.79 0 00149.57-7.58"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fahrrad3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.83,
    height: 7.54,
    x: 154.08,
    y: 895.81,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 3.12,
    transform: "rotate(19.21 164.999 899.405)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.9 925.58 130.12 920.66 163.02 898.9 168.44 900.74 132.9 925.58",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.26,
    points: "16.32 885.93 -13.69 825.59 -7.2 822.76 22.81 883.1 16.32 885.93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.64,
    cy: 927.05,
    r: 21.66,
    className: "parkingBikeIncreased_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1 928.1c-.61 6.39-9.88 26.28-28.42 19.46C112.37 944.13 4.92 898.26 15 881c7.11-12.2 82.2 12.12 121 25.62-.07.03 15.64 5.51 14.1 21.48z",
    className: "parkingBikeIncreased_before_svg__cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.6 950.9a71.77 71.77 0 1191.39-44.16A71.85 71.85 0 01-1.6 950.9zm45-129.08a64.92 64.92 0 1039.95 82.66 65 65 0 00-39.98-82.66z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.83 941.61 257.39 891.15 262.99 890.99 269.43 941.46 263.83 941.61",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.73 956.81a78.07 78.07 0 01-8.29-144 77.57 77.57 0 0159.65-3.43 78.07 78.07 0 018.29 144 77.57 77.57 0 01-59.65 3.43zm49.13-141a71.28 71.28 0 1043.87 90.76 71.36 71.36 0 00-43.87-90.79z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.19 899.78a85.71 85.71 0 00-59.56-16.9l-.79-15.57a3.39 3.39 0 00.35-3.39 3.28 3.28 0 00-.57-.87l-.48-9.5a3.37 3.37 0 00.66-2.2l-1.8-31.8a3.39 3.39 0 00-6.77.37l1.5 27-117.11-36 1.64-27.8a3.39 3.39 0 10-6.76-.4l-1.7 28.73L94 834.91a84.79 84.79 0 00-43.6-34.28 84.94 84.94 0 00-65.6 4A86.1 86.1 0 00-59 854a4.24 4.24 0 002.61 5.4 4.24 4.24 0 005.4-2.61c14.12-40.55 58.35-62.14 98.59-48.13a76.46 76.46 0 0139.2 30.86l-67.7 43.13a3.39 3.39 0 00.55 6l102.23 41.48a.44.44 0 00.16.06l.33.1h1.52l.29-.08.32-.13 132.15-59.94.68 13.43a86.56 86.56 0 00-68 57.08 4.24 4.24 0 008 2.79c14.13-40.55 58.35-62.14 98.59-48.12a76.86 76.86 0 0121.07 11.25 4.24 4.24 0 105.12-6.76zM90.24 845.35A77.94 77.94 0 0195 907.61a4.24 4.24 0 001.41 4.74l.31.22-68.43-27.75zm7.88 67.81a4.24 4.24 0 004.88-2.76 86.11 86.11 0 00-3.62-65.92c-.61-1.26-1.24-2.5-1.9-3.73l32.6-20.75-9.85 102.17zm29 8.31l10-103.64 118.85 36.49.43 8.52z",
    className: "parkingBikeIncreased_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.92,
    cy: 941.61,
    r: 6.76,
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#857d7a",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M282.93 813.68L274 789l-20.6 24-43.31 14.4c-2.91.86-5.19.37-4.33 3.28.52 1.76.46 1.71 2.08 2.27a5.42 5.42 0 003.36.08l41.64-12.29.82 12.19 7.61-.51-1.14-17 12.37-17.75 7.24 21c1.74-2.5 4.93-7.48 3.19-4.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.53,
    cy: 927.38,
    r: 6.76,
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.57,
    height: 5.54,
    x: 97.3,
    y: 937.53,
    className: "parkingBikeIncreased_before_svg__cls-25",
    transform: "rotate(-44.96 115.555 940.244)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.11,
    height: 10.05,
    x: 89.11,
    y: 950.02,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 4.16,
    transform: "matrix(.94 .33 -.33 .94 319.95 19.06)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.23 805.28l7.52-1 4.85 13c1 2.68.12 5.08-2 5.37-2.08.28-4.57-1.67-5.57-4.35z",
    className: "parkingBikeIncreased_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.38,
    x2: 209.1,
    y1: 824.13,
    y2: 830.25,
    fill: "#6784b3",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79 821.15l.66 8.77-14.93 4.08c-3.07.83-5.71-.46-5.89-2.88-.18-2.42 2.16-5.06 5.23-5.89z",
    className: "parkingBikeIncreased_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.39,
    x2: 99.64,
    y1: 912.07,
    y2: 913.77,
    className: "parkingBikeIncreased_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.74 770.46a9.36 9.36 0 01-3.24-5.94c-.39-3.76 1.56-7.26 3.18-10.16 1.31-2.35 5.18-9.28 12-12.1 3.84-1.59 6.78-1.12 9.87-.64a23.63 23.63 0 0114.26 7.38c5 5.47 4.21 9.78 10 14.13a25.89 25.89 0 006.08 3.11c8.1 3.43 13.48 3 22.58 7 5.09 2.21 6.39 3.63 6.69 5.62.5 3.46-2.15 7.79-4.66 10.15-4.66 4.38-10.36 3.39-16.32 2.15-10.09-2.09-15-3.86-29.25-7.65-4.31-1.15-4.82-1.19-9.39-2.45-8.22-2.25-15.66-4.61-21.8-10.6z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fahrrad2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.38,
    height: 3.93,
    x: 259.03,
    y: 640.5,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 1.63
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.38 660.77 251.16 658.82 263.63 642.47 266.61 642.44 253.38 660.77",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.2 661.24 164.09 636.68 166.79 634.18 191.91 658.73 189.2 661.24",
    className: "parkingBikeIncreased_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.53,
    cy: 662.22,
    r: 11.29,
    className: "parkingBikeIncreased_before_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.28 659.06c.79 3.24-.37 14.62-10.66 14.44-5.17-.09-65.91-4.24-63.93-14.44 1.41-7.23 42.54-8.13 63.93-8.13 0 0 8.67 0 10.66 8.13z",
    className: "parkingBikeIncreased_before_svg__cls-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52 696.29a37.41 37.41 0 1137.41-37.41 37.45 37.45 0 01-37.41 37.41zm0-71.24a33.84 33.84 0 1033.84 33.83 33.86 33.86 0 00-33.84-33.83z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.31 658.42 311.49 626.58 314.9 625.2 329.73 657.04 326.31 658.42",
    className: "parkingBikeIncreased_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.49 699.56a40.7 40.7 0 1128.76-11.92 40.39 40.39 0 01-28.76 11.92zm0-77.83a37.15 37.15 0 1037.15 37.15 37.19 37.19 0 00-37.15-37.15zM328.37 699.56a40.68 40.68 0 1128.77-11.92 40.41 40.41 0 01-28.77 11.92zm0-77.83a37.15 37.15 0 1037.15 37.15 37.19 37.19 0 00-37.15-37.15z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11 615.61a44.63 44.63 0 00-32.21 1.9l-3.06-7.51a1.75 1.75 0 00-.41-1.73 1.91 1.91 0 00-.42-.33l-1.87-4.59a1.77 1.77 0 00-.05-1.2l-6.32-15.35a1.77 1.77 0 10-3.27 1.35l5.36 13-63.8 2.39-4-14a1.77 1.77 0 10-3.4 1l4.13 14.46-14.1 17.86a44.5 44.5 0 00-58.95 3.79 44.88 44.88 0 00-13.08 31.83 2.21 2.21 0 004.42 0 40.47 40.47 0 0140.27-40.59 39.86 39.86 0 0124.58 8.46L190 659.14a1.76 1.76 0 001.3 2.85l57.42 2.89h.86l.12-.07.13-.09.14-.12 54.76-52.16 2.64 6.49a45.13 45.13 0 00-23.69 39.76 2.21 2.21 0 104.42 0 40.48 40.48 0 0140.27-40.59 40 40 0 0112.31 1.93 2.21 2.21 0 101.35-4.21zm-123.49 13a40.62 40.62 0 0113 29.84 2.26 2.26 0 002.2 2.14l-38.92-1.93zm15.2 32a2.45 2.45 0 002.22-2.14A44.88 44.88 0 00223 626.6c-.52-.51-1-1-1.58-1.51l12.5-15.82 12.67 52zm16-.83L237 607l64.75-2.42 1.68 4.11z",
    className: "parkingBikeIncreased_before_svg__cls-34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.37,
    cy: 658.88,
    r: 3.52,
    className: "parkingBikeIncreased_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69 695.88a37.41 37.41 0 1137.4-37.41 37.45 37.45 0 01-37.4 37.41zm0-71.25a33.84 33.84 0 1033.83 33.84 33.88 33.88 0 00-33.83-33.84z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.64 587.74a3.24 3.24 0 01-1.71-1.6 6.16 6.16 0 01-.06-3.7 9.25 9.25 0 012.63-5.3 5.77 5.77 0 013.19-1.29 8.23 8.23 0 015.52.89c2.24 1.26 2.45 2.76 4.82 3.57a9 9 0 002.34.36c3 .25 4.79-.46 8.22-.16 1.92.18 2.5.5 2.82 1.13a4.73 4.73 0 01-.43 3.85c-1.06 2-3 2.25-5.15 2.5-3.56.4-5.37.36-10.48.66-1.55.09-1.72.14-3.37.22-2.98.13-5.65.18-8.34-1.13z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.79 557.43a19 19 0 00-1.35 2.91l-7.06 24.34-18.85 14.53c-1.28.92-2.49 1.07-1.57 2.36.56.78.53.76 1.42.76a2.89 2.89 0 001.67-.54l18.38-13.19 2.5 5.86 3.65-1.55-3.48-8.19 6.67-23.72c.43-1.56-3.11-2.46-1.98-3.57z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.53,
    cy: 662.4,
    r: 3.52,
    fill: "#857d7a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.06,
    height: 2.89,
    x: 237.85,
    y: 669.53,
    className: "parkingBikeIncreased_before_svg__cls-25",
    transform: "rotate(-64.16 247.407 671.003)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.17,
    height: 5.24,
    x: 236.45,
    y: 677.66,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 2.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.75,
    x2: 302.12,
    y1: 568.4,
    y2: 557.6,
    className: "parkingBikeIncreased_before_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25 570l-4.36-2 1.82-8.6c.38-1.76 1.66-2.75 2.86-2.2 1.2.55 1.87 2.43 1.5 4.2z",
    className: "parkingBikeIncreased_before_svg__cls-34"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.51,
    x2: 274.53,
    y1: 595.32,
    y2: 600.78,
    className: "parkingBikeIncreased_before_svg__cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2 593.78L282 598l-6.65 4.55c-1.37.94-2.89.76-3.39-.4-.51-1.16.19-2.86 1.56-3.8z",
    className: "parkingBikeIncreased_before_svg__cls-34"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Fahrrad1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.83,
    height: 6.15,
    x: 906.62,
    y: 812.47,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 2.55,
    transform: "rotate(-180 915.535 815.545)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "933.3 844.22 936.77 841.17 917.24 815.55 912.57 815.51 933.3 844.22",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1033.87 844.96 1073.22 806.49 1068.98 802.56 1029.62 841.03 1033.87 844.96",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.19,
    cy: 846.5,
    r: 17.69,
    className: "parkingBikeIncreased_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.36 841.54c-1.25 5.09.56 22.93 16.69 22.64 8.1-.14 103.29-6.65 100.18-22.64-2.2-11.31-66.65-12.73-100.18-12.73 0 0-13.58 0-16.69 12.73z",
    className: "parkingBikeIncreased_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.61 841.27a58.62 58.62 0 1158.62 58.62 58.69 58.69 0 01-58.62-58.62zm5.6 0a53 53 0 1053-53 53.07 53.07 0 00-53 53z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "819.02 840.55 842.24 790.66 836.89 788.49 813.66 838.38 819.02 840.55",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.21 886.34a63.75 63.75 0 1145.08 18.66 63.33 63.33 0 01-45.08-18.66zm-13.14-45.08a58.22 58.22 0 1058.22-58.26 58.29 58.29 0 00-58.22 58.26zM770.71 886.34A63.75 63.75 0 11815.79 905a63.33 63.33 0 01-45.08-18.66zm-13.14-45.08A58.22 58.22 0 10815.79 783a58.28 58.28 0 00-58.22 58.26z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792 777.83a3.47 3.47 0 004.36 2.23 62.47 62.47 0 0119.28-3c34.79 0 63.1 28.53 63.1 63.6a3.47 3.47 0 006.93 0 70.71 70.71 0 00-37.13-62.3l4.14-10.17 85.81 81.73.21.19.2.14h.07l.19.1h.07l.19.07h.09l.19.06h.8l90-4.52a2.77 2.77 0 002-4.48L992 790.21a62.46 62.46 0 0138.5-13.21c34.8 0 63.11 28.53 63.11 63.6a3.46 3.46 0 106.92 0 70.33 70.33 0 00-20.5-49.86 69.67 69.67 0 00-92.37-5.94l-22.1-28 6.44-22.66a2.77 2.77 0 10-5.33-1.51l-6.2 21.88-100-3.73 8.4-20.39a2.77 2.77 0 10-5.12-2.1l-9.9 24.05a2.8 2.8 0 00-.09 1.87l-2.92 7.2a3 3 0 00-.67.52 2.77 2.77 0 00-.64 2.71l-4.79 11.8a70 70 0 00-50.48-3 3.47 3.47 0 00-2.26 4.39zm232.91 63.06l-60.2 3a3.46 3.46 0 002.66-3.37 63.65 63.65 0 0120.37-46.75zM944 845l19.85-81.44 19.57 24.8c-.83.77-1.66 1.56-2.46 2.37a70.29 70.29 0 00-20.51 49.86 3.46 3.46 0 003 3.43zm-89.07-82.3l2.62-6.45L959 760l-20.14 82.62z",
    className: "parkingBikeIncreased_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 815.79,
    cy: 841.26,
    r: 5.52,
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.67 840.62a58.62 58.62 0 1158.62 58.62 58.68 58.68 0 01-58.62-58.62zm5.6 0a53 53 0 1053-53 53.08 53.08 0 00-53 53z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.4 738.35a5.24 5.24 0 003-2.3c1.06-1.82.86-4.06.7-5.9-.13-1.5-.52-5.92-3.35-8.92a9.22 9.22 0 00-4.9-2.58 13.25 13.25 0 00-9 .52c-3.79 1.65-4.38 4-8.31 4.93a14.56 14.56 0 01-3.81.2c-4.92-.1-7.58-1.53-13.12-1.6-3.1 0-4.09.39-4.7 1.34-1 1.65-.68 4.47.06 6.25 1.38 3.3 4.51 4.09 7.84 4.82 5.62 1.24 8.54 1.46 16.67 2.78 2.46.4 2.73.5 5.35.9 4.73.72 9.07 1.21 13.57-.44z",
    className: "parkingBikeIncreased_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.44 682.29a30.86 30.86 0 012.11 4.57L870.62 725l29.53 22.76c2 1.45 3.91 1.68 2.46 3.69-.88 1.23-.82 1.2-2.22 1.2a4.45 4.45 0 01-2.61-.84L869 731.14l-3.91 9.18-5.73-2.43 5.46-12.84-10.46-37.22c-.7-2.39 4.85-3.83 3.08-5.54z",
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 936.19,
    cy: 846.78,
    r: 5.52,
    className: "parkingBikeIncreased_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.53,
    height: 29.87,
    x: 940.44,
    y: 845.29,
    className: "parkingBikeIncreased_before_svg__cls-25",
    transform: "rotate(-25.84 942.526 860.137)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.77,
    height: 8.21,
    x: 936.05,
    y: 870.69,
    className: "parkingBikeIncreased_before_svg__cls-24",
    rx: 3.4,
    transform: "rotate(-180 947.94 874.795)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 862.19,
    x2: 856.92,
    y1: 699.49,
    y2: 682.56,
    className: "parkingBikeIncreased_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.72 701.93l6.83-3.13-2.86-13.47c-.59-2.78-2.59-4.32-4.47-3.46-1.89.87-2.94 3.81-2.35 6.59z",
    className: "parkingBikeIncreased_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 890.78,
    x2: 900.15,
    y1: 741.67,
    y2: 750.22,
    className: "parkingBikeIncreased_before_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.27 739.26l-2.87 6.59 10.42 7.15c2.15 1.47 4.53 1.18 5.32-.64.79-1.82-.31-4.48-2.45-6z",
    className: "parkingBikeIncreased_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 963.27,
    x2: 965.11,
    y1: 843.99,
    y2: 843.9,
    className: "parkingBikeIncreased_before_svg__cls-24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Baum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Baum-2",
    "data-name": "Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349.71,
    cy: 302.9,
    r: 67.07,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.94 304.18A67.07 67.07 0 01359 237.11c1.54 0 3.06.06 4.57.16a67.08 67.08 0 10-18.44 132.55 67.1 67.1 0 01-53.19-65.64z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M340.77 499.63a3.68 3.68 0 01-2.65-1.13 3.46 3.46 0 01-1-2.6l10.69-155.82-12-12.05a1.4 1.4 0 011-2.39 1.43 1.43 0 01.61.14l11 5.34 1.58-22.78.1-1.85a3.49 3.49 0 017-.12l1 14.08 11-5.82h.16a2.83 2.83 0 01.41 0 2.23 2.23 0 012.1 1.53 2.19 2.19 0 01-.77 2.48l-11.81 8.53L370 495.79a3.53 3.53 0 01-.92 2.66 3.65 3.65 0 01-2.69 1.18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.61 304.18a2.39 2.39 0 012.47 2.27l1.15 15.6 12.21-6.46a1 1 0 01.24 0 1.23 1.23 0 01.72 2.22l-12.23 8.83L369 495.86a2.58 2.58 0 01-2.61 2.77h-25.62a2.58 2.58 0 01-2.62-2.68l10.72-156.25-12.35-12.38a.4.4 0 01.28-.68.42.42 0 01.18 0l12.37 6 1.65-24.23.09-1.86a2.42 2.42 0 012.5-2.37m0-2a4.38 4.38 0 00-4.49 4.26l-.1 1.86-1.46 21.28-9.71-4.7a2.39 2.39 0 00-2.74 3.85l11.7 11.74-10.64 155.34a4.54 4.54 0 001.24 3.38 4.7 4.7 0 003.38 1.44h25.57a4.66 4.66 0 003.43-1.51 4.54 4.54 0 001.17-3.44l-10.7-168.08 11.34-8.19a3.24 3.24 0 00-1.9-5.84 2.94 2.94 0 00-.59.05l-.31.05-.27.15-9.51 5-.92-12.54a4.42 4.42 0 00-4.47-4.13z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "parkingBikeIncreased_before_svg__cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.32 323.34l13.43-7.11a1.19 1.19 0 00-1.31-.64l-12.21 6.46zM351.81 333.85l1.74-25.44.09-1.86a2.38 2.38 0 011.23-2.05 2.51 2.51 0 00-3.76 2.05l-.09 1.86-1.66 24.26zM340.67 496l10.73-156.3-11.65-11.7-2.75-1.32a.4.4 0 00-.46.64l12.35 12.38L338.15 496a2.58 2.58 0 002.62 2.68h2.52a2.59 2.59 0 01-2.62-2.68z",
    className: "parkingBikeIncreased_before_svg__cls-43"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "parkingBikeIncreased_before_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M1089.89 980.65h-3.09c-18.15 0-32.91-9.38-32.91-20.9 0-9.42 9.79-17.53 23.74-20.07-3.72-3.45-5.73-7.56-5.73-11.81 0-9.41 9.66-17.5 23.71-20.06a13.66 13.66 0 01-.61-4c0-10.2 11.21-18.7 26.84-20.52.93-11 15.31-19.78 32.87-19.78a52 52 0 018.87.76c6.13-5.7 16.2-9.07 27.16-9.07a47.88 47.88 0 0117.55 3.19c5.62-5 14.59-8.2 24.32-8.66 6.11-5.84 16.3-9.32 27.42-9.32 17.68 0 32.15 8.9 32.88 20 11.18 1.75 20.19 7.19 23.53 14.18 15.8 0 29 6.93 32.14 16.63 15.65.23 28.61 7.21 31.5 16.91 13.13 2.94 21.88 10.77 21.88 19.69 0 5-2.64 9.61-7.51 13.34 10.84 3.56 17.67 10.62 17.67 18.54 0 9.52-10.11 17.83-24.59 20.21h-.12l-295.92.67c-.49.05-1.01.07-1.6.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 841.89c17.35 0 31.41 8.69 31.41 19.4v.41c11.84 1.53 21.21 7.18 24.06 14.4h.92c15.82 0 28.88 7.23 31.06 16.64h.35c15.85 0 28.93 7.26 31.07 16.68 12.53 2.55 21.59 9.83 21.59 18.42 0 5.45-3.65 10.37-9.5 13.89 11.52 2.88 19.66 9.84 19.66 18 0 9-9.9 16.52-23.33 18.73l-295.87.67c-.52 0-1 .06-1.53.06-1 0-2-.06-3.09-.06-17.35 0-31.41-8.69-31.41-19.4 0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.8 0-9.19 10.36-16.87 24.26-18.87a12.61 12.61 0 01-1.16-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.06-19.4 31.41-19.4a49.56 49.56 0 019.36.88c5.54-5.51 15.39-9.2 26.67-9.2a45.78 45.78 0 0117.86 3.46c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.44-9.3 26.78-9.3m0-3c-11.26 0-21.62 3.48-28 9.35-9.59.55-18.17 3.56-24 8.41a49.72 49.72 0 00-17.25-3c-11 0-21.18 3.34-27.63 9a52.9 52.9 0 00-8.4-.66c-18 0-32.39 8.58-34.22 19.94-15.79 2.2-27 11.15-27 21.86a14 14 0 00.28 2.8c-13.93 3-23.38 11.43-23.38 21.22a16.75 16.75 0 004.29 10.9c-13.23 3.2-22.3 11.45-22.3 21 0 12.56 15.12 22.4 34.41 22.4h3.09c.61 0 1.15 0 1.67-.06l295.73-.67h.48c15.22-2.5 25.85-11.42 25.85-21.69 0-8-6.2-15.07-16.23-19.07 3.95-3.7 6.07-8.11 6.07-12.81 0-9.44-8.85-17.72-22.22-21-3.48-9.66-16.21-16.6-31.59-17.11-3.8-9.59-16.79-16.38-32.29-16.65-3.72-6.88-12.24-12-23.07-14-1.64-11.5-16.1-20.22-34.26-20.22z",
    className: "parkingBikeIncreased_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "parkingBikeIncreased_before_svg__cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1069.38 968.7c0-9.55 11.16-17.46 25.86-19.08-4.87-3.42-7.84-7.89-7.84-12.8 0-9.19 10.36-16.87 24.25-18.87a12.61 12.61 0 01-1.16-5.15c0-9.75 11.65-17.79 26.82-19.17a1.79 1.79 0 010-.23c0-10.72 14.06-19.4 31.41-19.4a49.57 49.57 0 019.36.87c5.54-5.51 15.4-9.19 26.67-9.19a45.68 45.68 0 0117.87 3.46c5.26-5.11 14.27-8.57 24.64-8.94 5.53-5.57 15.44-9.3 26.78-9.3a47.75 47.75 0 0114.44 2.18c-5-6.6-15.84-11.19-28.43-11.19-11.34 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.84-24.65 8.94a45.6 45.6 0 00-17.86-3.46c-11.27 0-21.13 3.68-26.68 9.19a50.22 50.22 0 00-9.35-.87c-17.35 0-31.42 8.69-31.42 19.4v.23c-15.16 1.38-26.81 9.43-26.81 19.17a12.45 12.45 0 001.16 5.15c-13.9 2-24.25 9.68-24.25 18.87 0 4.91 3 9.38 7.84 12.8-14.7 1.62-25.86 9.54-25.86 19.08 0 7.5 6.9 14 17 17.22a13.55 13.55 0 01-3.01-8.21z",
    className: "parkingBikeIncreased_before_svg__cls-43"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingBikeIncreasedbefore);
export default __webpack_public_path__ + "static/media/parkingBikeIncreased.before.a2be83e0.svg";
export { ForwardRef as ReactComponent };